/** مقارنة build-stamp مع آخر تحميل — تحديث SW وإعادة تحميل عند نشر جديد */
const LS_KEY = 'omdaa.buildStamp';

export async function syncAppBuildCache() {
  try {
    const r = await fetch('/build-stamp.json', { cache: 'no-store', credentials: 'same-origin' });
    if (!r.ok) return;
    const { v } = await r.json();
    if (!v) return;
    const prev = localStorage.getItem(LS_KEY);
    if (prev && prev !== v) {
      localStorage.setItem(LS_KEY, v);
      if (typeof caches !== 'undefined') {
        const keys = await caches.keys();
        await Promise.all(keys.filter((k) => k.startsWith('omdaa-shell-')).map((k) => caches.delete(k)));
      }
      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration('/');
        try { await reg?.update(); } catch { /* ignore */ }
        reg?.waiting?.postMessage({ type: 'SKIP_WAITING' });
      }
      location.reload();
      return;
    }
    localStorage.setItem(LS_KEY, v);
  } catch {
    /* offline أو أول زيارة */
  }
}
